"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ControlRendererContext_1 = __importDefault(require("../ControlRendererContext"));
const controlCreateEventCallbacksFromDefinition_1 = __importDefault(require("../shared/controlCreateEventCallbacksFromDefinition"));
const useAppStateStore_1 = __importDefault(require("./useAppStateStore"));
const controlEventsEnsureNoLegacy_1 = __importDefault(require("../shared/controlEventsEnsureNoLegacy"));
const useAppStateSelector_1 = __importDefault(require("./useAppStateSelector"));
const appStateSelectFunctionsAreEnabled_1 = __importDefault(require("../shared/appStateSelectFunctionsAreEnabled"));
const appStateSelectFunctionsDefinitions_1 = __importDefault(require("../shared/appStateSelectFunctionsDefinitions"));
const useControlEvents = (control) => {
    var _a;
    const { functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const functionsDefinitions = (0, useAppStateSelector_1.default)(appStateSelectFunctionsDefinitions_1.default);
    const functionsAreEnabled = (0, useAppStateSelector_1.default)(appStateSelectFunctionsAreEnabled_1.default);
    const appStateStore = (0, useAppStateStore_1.default)();
    const processorInControlContext = (_a = processor.root.getControlRunContext(control.id)) === null || _a === void 0 ? void 0 : _a.processor;
    const events = (0, react_1.useMemo)(() => (0, controlCreateEventCallbacksFromDefinition_1.default)({
        functionsAreEnabled,
        functionsDefinitions,
        processor: processorInControlContext !== null && processorInControlContext !== void 0 ? processorInControlContext : processor,
        store: appStateStore,
        controlId: control.id,
        events: (0, controlEventsEnsureNoLegacy_1.default)(control.events),
    }), [
        control.id,
        control.events,
        processor,
        appStateStore,
        functionsAreEnabled,
        functionsDefinitions,
        processorInControlContext,
    ]);
    (0, react_1.useEffect)(() => {
        const eventFunction = events && control.triggeredEvent && events[control.triggeredEvent];
        if (eventFunction) {
            eventFunction();
        }
    }, [events, control.triggeredEvent]);
    return events;
};
exports.default = useControlEvents;
